<mat-card-title>
	Academic Risk Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'AcademicRiskReport_Overview'"></help-text-btn>
</mat-card-title>
<mat-divider> </mat-divider>
<br>
<div class="row" style="padding-left:12px;">
	<mat-card appearance="outlined" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="min-width:450px;">
		<h2>
			Search Criteria
		</h2>
		<mat-card-content>
			<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
				[required]="true" #appRegionCode>
			</region-dropdown-two-way>

			<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
				[required]="false" #appCountyCode [regions]="chosenRegions">
			</county-dropdown-two-way>

			<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
				[reset]="resetField" [required]="false" #appSchoolDistrictCode [regions]="chosenRegions"
				[counties]="chosenCounties">
			</district-dropdown-two-way>

			<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
				#appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
				[schoolDistricts]="chosenSchoolDistricts">
			</school-dropdown-two-way>

			<app-school-year [label]="'Assessment School Year'" [yearType]="'SchoolYear'"
				(performancePeriodEvent)="performancePeriodEvent($event)" [minYear]="2016" [currentYearModifier]="-1"
				[yearsForward]="0" [reset]="resetField" [required]="true">
			</app-school-year>
		</mat-card-content>
		<mat-card-actions>
			<span style="padding:5px;padding-bottom:10px;">
				<span style="padding-right:15px;">
					<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
						(click)="search()">
						<mat-icon *ngIf="isLoading">
							<mat-spinner diameter="18"> </mat-spinner>
						</mat-icon>
						Search
					</button>
				</span>
				<span style="padding-right:15px;">
					<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
				</span>
				<span style="padding-right:15px;">
					<button [disabled]="!(results.length > 0)" mat-raised-button [matMenuTriggerFor]="menu">
						Export<mat-icon>more_vert</mat-icon>
					</button>
					<div class="spinner-overlay" *ngIf="isExporting && (progressCurrentValue < 100)">
						<!-- <mat-progress-spinner [color]="progressColor" [mode]="progressType"
							[value]="progressCurrentValue">
						</mat-progress-spinner> -->
						
						<mat-progress-spinner 
							[color]="progressColor"
							mode="indeterminate"
							[value]="progressCurrentValue">
						</mat-progress-spinner>
					</div>
					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="downloadXLS()">
							<span>
								<i class="fa fa-file"></i>
								Export to Excel<!-- XLS - Export # Schools (SCHOOLYEAR)--></span>
						</button>
						<!-- <button mat-menu-item (click)="downloadPDF()">
							<span>
								<i class="fa fa-file"></i>
								PDF - Export # Schools (SCHOOLYEAR)</span>
						</button> -->
					</mat-menu>
					
				</span>
			</span>
		</mat-card-actions>
	</mat-card>
</div>

<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<h2>
		Academic Risk Report - {{results.length}} {{displayName}} {{'(' + currentPerformancePeriod + ')'}}
		<button mat-button [matMenuTriggerFor]="tableControlMenu" class="pull-right">
			<mat-icon>menu</mat-icon>
		</button>
		<mat-menu #tableControlMenu="matMenu">
			<button mat-menu-item (click)="expandAll(results)">
				<span>
					Expand All
				</span>
			</button>
			<button mat-menu-item (click)="collapseAll(results)">
				<span>
					Collapse All
				</span>
			</button>
		</mat-menu>
	</h2>
	<hr />

	<div class="row">
		<mat-form-field>
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter()" />
		</mat-form-field>
	</div>

	<div *ngFor="let cur of results; let i = index" class="margin-top-sm">
		<div>
			<h3>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.CODE ? '(' + cur.CODE + ')' :
					''}} {{cur.NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.COUNTY_NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.DISTRICTS}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.SCHOOL_NAME}}</span>

				<span class="cursor-pointer" (click)="toggleShow(cur)"> {{'(' + (filter.length
					=== 0 ? '' : tableDataSources[i]?.filteredData?.length + '/') + cur.STUDENTS!.length + ')'}}</span>

				<mat-icon class="v-align-middle cursor-pointer" [color]="cur.SHOW ? 'primary' : ''"
					(click)="toggleShow(cur)">
					{{cur.SHOW ? 'expand_more' : 'chevron_right'}}
				</mat-icon>

				<span style="float:none;">&nbsp;<a matTooltip="Download XLS" matTooltipPosition="below"
						(click)="downloadXLS(cur.SCHOOL_NAME)"><i class="fa fa-file"
							style="color:black;transform: scale(1.4);"></i><!--<i class="fa fa-file-excel-o fa-fw success" style="transform: scale(1.4);"></i>--></a>
					&nbsp;
					<!-- <a  matTooltip="Download PDF" matTooltipPosition="below" (click)="downloadPDF(cur.SCHOOL_NAME)"><i class="fa fa-file-pdf-o fa-fw fa-lg danger"></i></a> -->
				</span>
			</h3>
		</div>
		<div>
			<mat-table [dataSource]="tableDataSources[i]" class="mat-elevation-z1 table-responsive" matSort
				(matSortChange)="announceSortChange($event)"
				[hidden]="!cur.SHOW || tableDataSources[i]?.filteredData?.length === 0">

				<ng-container matColumnDef="SCHOOL.COUNTy.COUNTY_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;"> County
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:80px;"> {{element.SCHOOL.COUNTy.COUNTY_NAME}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SCHOOL.SCHOOL_DISTRICT.DISTRICTS">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;"> District
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:100px;">
						{{element.SCHOOL.SCHOOL_DISTRICT.DISTRICTS}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="SCHOOL.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> School
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.SCHOOL.NAME}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="MSD_NUMBER">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> MSD Number
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;">
						<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
							[displayText]="element.MSD_NUMBER">
						</edit-child-modal-btn>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SSID">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> SSID </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.SSID}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="PERSON.LAST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> Name </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.PERSON.LAST_NAME |
						titlecase}}{{(element.SECOND_LAST_NAME
						? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
						titlecase}}
						{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
				</ng-container>


				<ng-container matColumnDef="GRADES">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;"> Grade </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:80px;"> {{element.GRADES}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="QAD">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;"> QAD </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:100px;"> {{element.QAD | simpleDate}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="CAASPP_ELA_SCORE">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> CAASPP ELA
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.CAASPP_ELA_SCORE}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="CAASPP_MATH_SCORE">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> CAASPP Math
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.CAASPP_MATH_SCORE}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="CELDT_SCORE">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;"> CELDT </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:80px;"> {{element.CELDT_SCORE}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="ELPAC_SCORE">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;"> ELPAC </mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:80px;"> {{element.ELPAC_SCORE}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="EL_INDICATOR">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;"> EL Status
					</mat-header-cell>
					<mat-cell *matCellDef="let element" style="min-width:80px;">
						<mat-icon>
							{{element.EL_INDICATOR ? 'check_box' : 'check_box_outline_blank'}}
						</mat-icon>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"
					[ngClass]="{'terminatedRow': row.QAD && isQadExpired(row.QAD)}" [matTooltip]="'QAD Expired'"
					[matTooltipPosition]="'above'" [matTooltipDisabled]="row.QAD && !isQadExpired(row.QAD)"
					[matTooltipClass]="'terminatedTooltip'"></mat-row>
			</mat-table>
		</div>
		<div style="width:100%;">
			<mat-paginator class="custom-paginator" #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
				aria-label="Select page of periodic elements"
				[hidden]="!cur.SHOW || tableDataSources[i]?.filteredData?.length === 0">
			</mat-paginator>
		</div>
	</div>

</div>